import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyCacheService } from '../services/currency-cache.service';
import {
  formatInstrumentQuantity,
  isInstrumentSymbol,
} from '../helpers/balance.helper';

@Pipe({ name: 'tradeAmount', standalone: true })
export class TradeAmountPipe implements PipeTransform {
  transform(
    value: any,
    symbol: string,
    side: 'buy' | 'sell',
    type: 'amount' | 'total'
  ): string {
    const amount =
      typeof value === 'string' ? parseFloat(value) : Number(value);
    if (isNaN(amount)) return '';

    const [base, quote] = (symbol ?? '').split('/');

    let currency: string;
    if (type === 'total') {
      // total is always in quote currency (what you pay or receive in settlement)
      currency = side === 'buy' ? quote : base;
    } else {
      // amount is always in base currency (what you buy or sell)
      currency = side === 'buy' ? base : quote;
    }

    if (isInstrumentSymbol(currency)) {
      return formatInstrumentQuantity(amount);
    }

    return amount.toFixed(CurrencyCacheService.getPrecision(currency ?? ''));
  }
}
